<div class="mb-dashboard">
    <div class="container">

        <div class="mb-profile-card">
            <h2>Team Members</h2>
            <div class="col-12">
                <p class="btn btn-light rounded-pill addbtn mb-0" (click)="addPage()" style="margin-left: 10px;" title="Add Member"><i class="ri-add-line"></i> Add Member</p>
              </div>
        </div>

        <!-- Add Team Modal Popup -->
        <div class="mb-cibil-popup" *ngIf="isShowAddTeam" (click)="closeTeamPage()">
            <form #teamForm="ngForm" class="agent-profile" (ngSubmit)="onAddTeamSubmit(teamForm)" (click)="$event.stopPropagation()">
                <button type="button" class="close-btn" (click)="closeTeamPage()" aria-label="Close">&times;</button>
                <h4 style="margin-top: 0; margin-bottom: 25px;">Add Team</h4>

                <div class="mb-profile-name">
                    <div class="row g-2">
                      
                        <div class="col-12">
                            <label for="teamName">Team Name</label><span class="text-danger">*</span>
                            <input type="text" name="teamName" class="form-control" placeholder="Team Name" [(ngModel)]="team.teamName" required> 
                        </div>
                        <div class="col-12">
                            <label for="teamDescription">Description</label>
                            <textarea name="teamDescription" class="form-control" placeholder="Team Description (Optional)" [(ngModel)]="team.teamDescription" rows="3"></textarea>
                        </div>
                        <div class="col-12">
                            <button type="submit" class="btn btn-primary" [disabled]="!teamForm.valid">Add Team</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <!-- Add Member Modal Popup -->
      <!-- Add Member Modal Popup -->
<div class="mb-cibil-popup" *ngIf="isShow" (click)="closePage()">

    <form #agentForm="ngForm"
          class="agent-profile"
          (ngSubmit)="onAddTeamSubmit(agentForm)"
          (click)="$event.stopPropagation()">

        <button type="button"
                class="close-btn"
                (click)="closePage()"
                aria-label="Close">
            &times;
        </button>

        <h4 style="margin-top:0;margin-bottom:25px;">Add Team Member</h4>

        <div class="mb-profile-name">
            <div class="row g-2">

                <div class="col-12">
                    <label>Name</label><span class="text-danger">*</span>
                    <input
                        type="text"
                        name="name"
                        class="form-control"
                        [(ngModel)]="member.name"
                        required>
                </div>

                <div class="col-12">
                    <label>Mobile</label><span class="text-danger">*</span>
                    <input
                        type="text"
                        name="mobileNumber"
                        class="form-control"
                        [(ngModel)]="member.mobileNumber"
                        required
                        pattern="^[0-9]{10}$"
                        #mobile="ngModel">
                </div>

                <div class="col-12">
                    <label>Role</label><span class="text-danger">*</span>

                    <select
                        class="form-control"
                        name="role"
                        [(ngModel)]="member.role"
                        required>

                        <option value="">Select Role</option>
                        <option value="staff">Staff</option>
                        <option value="cp">Channel Partner</option>
                        <option value="agent">Agent</option>

                    </select>
                </div>

                <div class="col-12">
                    <button
                        type="submit"
                        class="btn btn-primary"
                        [disabled]="!agentForm.valid">
                        Add Member
                    </button>
                </div>

            </div>
        </div>

    </form>

</div>
    <!-- <div class="container">
        <div class="row">
            <div class="col-xl-12 col-lg-12">
                <div class="all-leads">
                    <div class="card shadow mb-4">
                        <div class="card-body">
                            <div class="mb-3">
                                <h3>Team Members</h3>
                                <div class="right-search">
                                    <input type="text" class="form-control mb-3 rounded-4" placeholder="Search">
                                    <label for="Sort by:">Sort by:</label>
                                    <select class="form-control  rounded-4 mt-1">
                                        <option>Monthly</option>
                                        <option>Weekly</option>
                                        <option>Daily</option>
                                    </select>
                                </div>
                            </div>


                            <div class="table-head-fixed">
                                <table class="table table-striped">
                                    <thead class="table-dark">
                                        <tr>
                                            <th><input type="checkbox"></th>
                                            <th>Name</th>
                                            <th>Mobile Number</th>
                                            <th>Email ID</th>
                                            <th>Date Added</th>
                                            <th>City</th>
                                            <th>Remarks</th>
                                          </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                        *ngFor="let member of filteredMembers | paginate: { itemsPerPage: itemsPerPage, currentPage: p }">
                                        <td><input type="checkbox"></td>
                                        <td>{{ member.personalDetails.firstName }}</td>
                                        <td>{{ member.personalDetails.mobile || 'N/A' }}</td>
                                        <td>{{ member.personalDetails.email || 'N/A' }}</td>
                                        <td>{{ member.createdAt | date: 'dd-MM-yyyy' }}</td>
                                        <td>{{ member.city || 'N/A' }}</td>
                                        <td>{{ member.activeStatus === 1 ? 'Active' : 'Inactive' }}</td>
                                      </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <pagination-controls (pageChange)="p = $event"></pagination-controls>
        
                        <div class="go-to-page">
                          <label for="pageSelect">Go to page:</label>
                          <select id="pageSelect" (change)="goToPage($event.target.value)">
                            <option *ngFor="let page of totalPagesArray" [value]="page">{{ page }}</option>
                          </select>
                        </div>
                      </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="container">
        <div class="row">
            <div class="col-xl-12 col-lg-12">
                <div class="all-leads">
                    <div class="card shadow mb-4">
                        <div class="card-body">
                            <div class="mb-3">
                                <h3>Team Members</h3>
                                <div class="right-search">
                                    <input type="text" class="form-control mb-2 mb-md-3 rounded-4" placeholder="Search">
                                    <label for="Sort by:" class="me-2">Sort by:</label>
                                    <select class="form-control rounded-4">
                                        <option>Monthly</option>
                                        <option>Weekly</option>
                                        <option>Daily</option>
                                    </select>
                                </div>
                            </div>
                            <button class="btn btn-success mt-3">Export to Excel</button>

    
                            <div class="table-head-fixed">
                                <table class="table table-striped">
                                    <thead class="table-dark">
                                        <tr>
                                            <th><input type="checkbox"></th>
                                            <th>Name</th>
                                            <th>Mobile Number</th>
                                            <th>Date Added</th>
                                            <th>Type</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let member of filteredMembers | paginate: { itemsPerPage: itemsPerPage, currentPage: p }">
                                            <td><input type="checkbox"></td>
                                            <td>{{ member.name }}</td>
                                            <td>{{ member.mobile || 'N/A' }}</td>
                                            <td>{{ member.createdAt | date: 'dd-MM-yyyy' }}</td>
                                            <td>{{ member.type || 'N/A' }}</td>
                                            <td>{{ member.status === 1 ? 'Active' : 'Inactive' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                         
                            <div class="d-flex flex-wrap justify-content-between align-items-center mt-3" style="float: right;">
                                <pagination-controls (pageChange)="p = $event"></pagination-controls>
                            </div>
                        </div>
                       
                    </div>
                        <!-- <div class="go-to-page">
                            <label for="pageSelect">Go to page:</label>
                            <select id="pageSelect" (change)="goToPage($event.target.value)">
                                <option *ngFor="let page of totalPagesArray" [value]="page">{{ page }}</option>
                            </select>
                        </div> -->
                </div>
            </div>
        </div>
    </div>
    
    <div class="container">
        <div class="row">
            <div class="col-lg-12 pb-4 text-center">
                <small class="copy-right-text">All trademarks, logos and names are properties of their respective
                    owners. Copyright © 2024 - All rights reserved.</small>
            </div>
        </div>

    </div>

    <!-- <footer>
        <nav class="navbar fixed-bottom bg-secondary">
            <div class="container-fluid">
                <ul class="nav justify-content-center">
                    <li class="nav-item">
                        <a class="nav-link text-white" href="#">Terms & Conditions </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link text-white" href="#">Policy</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link text-white" href="#">Home</a>
                    </li>
                </ul>
            </div>
        </nav>                            
    </footer> -->
</div>